enum Roles
{
	//None = 'None',
	Admin = 'Admin',
	Reviewer = 'Reviewer',
	Analyst = 'Analyst',
	//KnowledgeMaps = 'KnowledgeMaps',
	SCUser = 'SC User',
	SCAnalyst = 'SC Analyst',
};

export default Roles;